<template>
  <div class="home min-container">
    <div class="container">
      <div class="left">
        <p class="p1">
          ERROR 404
        </p>
        <p class="p2">
          Sorry, but the page that you requested does not exist
        </p>
        <div
          class="button1"
          @click="toHome()"
        >
          <p>Return to shop</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  data () {
    return {
      showAnimal: false
    }
  },
  mounted () {
    document
      .querySelector('#app')
      .scrollIntoView({ block: 'start', behavior: 'smooth' })
    setTimeout(() => {
      this.showAnimal = true
    }, 1000)
  },
  methods: {
    toHome () {
      this.$router.push({ name: 'home' })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.home {
  position: relative;
  width: 100%;
  height: 770px;
  background-image: url(/pc/static/img/hom/404.jpg);
  background-repeat: no-repeat;
  background-position: center center;
  color: #323232;
  overflow: hidden;
  .container {
    position: relative;
    height: 100%;
  }
  .left {
    position: relative;
    z-index: 2;
    width: 550px;
    padding-top: 130px;
    .p1 {
      font-size: 66px;
      line-height: 76px;
      font-weight: 500;
      color: #ffffff;
    }
    .p2 {
      font-size: 16px;
      margin-top: 10px;
      margin-bottom: 30px;
      color: #ffffff;
    }
    .button1 {
      width: 200px;
      height: 40px;
      background-color: #036253;
      text-align: center;
      border-radius: 5px;
      cursor: pointer;
      margin-bottom: 6px;
      p {
        line-height: 40px;
        font-size: 20px;
        color: #ffffff;
      }
    }
  }
}
</style>
